var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 21V19C20.6667 17.9391 20.2452 16.9217 19.4951 16.1716C18.7449 15.4214 17.7275 15 16.6667 15H8.66666C7.60579 15 6.58837 15.4214 5.83823 16.1716C5.08808 16.9217 4.66666 17.9391 4.66666 19V21M16.6667 7C16.6667 9.20914 14.8758 11 12.6667 11C10.4575 11 8.66666 9.20914 8.66666 7C8.66666 4.79086 10.4575 3 12.6667 3C14.8758 3 16.6667 4.79086 16.6667 7Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.15e24d769854db98cd0c29966992c79d.svg";
export { ForwardRef as ReactComponent };